import React from "react";
import Navbar from "../molecules/Navbar";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useState, useEffect } from "react";
import Iframe from "react-iframe";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import VideoCard from "../atoms/VideoCard";
import "./VideoPage.css";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { Button } from "@mui/material";
import { config } from "../App.js";
export default function VideoPage() {
  const [videoDetails, setVideoDetails] = useState({
    votes: {},
    previewImage: "",
    viewCount: 0,
    videoLink: "",
    title: "",
    genre: "",
    contentRating: "",
    releaseDate: "",
    _id: "",
  });
  const [allVideo, setAllVideos] = useState([]);
  const [params, setAllParams] = useState(useParams().videoId);
  const [isClicked, setIsClicked] = useState("");

  const param = useParams();

  const getParam = (param) => {
    setAllParams(param);
  };

  const fetchVideo = async (url) => {
    try {
      const res = await axios.get(url);
      const result = res.data;

      setVideoDetails(result);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAllVideo = async (url) => {
    try {
      const res = await axios.get(url);
      const result = res.data;
      setAllVideos(result.videos);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpVote = async () => {
    const data = {
      vote: "upVote",
      change: "increase",
    };

    try {
      const response = await axios.patch(
        `${config.endpoint}/${params}/votes`,
        data
      );
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDownVote = async () => {
    const data = {
      vote: "downVote",
      change: "increase",
    };

    try {
      const response = await axios.patch(
        `${config.endpoint}/${params}/votes`,
        data
      );
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    let url;
    if (params === null) {
      url = config.endpoint;
    } else {
      url = config.endpoint + "/" + params;
    }
    fetchVideo(url);
    setIsClicked("");
    fetchAllVideo(config.endpoint);
  }, [params]);
  return (
    <div>
      <Navbar />
      <div className="iframe-parent" style={{ width: "80%", margin: "25px 10%", borderRadius: "10px" }}>
        <Iframe
          style={{
            margin: "10%",
            boder: "none",
            borderRadius: "10.449px",
            border: "none",
          }}
          url={`https://www.${videoDetails.videoLink}`}
          width="100%"
          height="523px"
          frameBorder="0"
          // display="block"
        />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          left: "10%",
          margin: "0px 10%",
          borderBottom: "2px solid rgba(216, 216, 216, 0.5)",
        }}
      >
        <div>
          <p className="headingVideo">{videoDetails.title}</p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",

              // margin: "0 10%",
            }}
          >
            <span className="detailsVideo">{videoDetails.contentRating}</span>

            <FiberManualRecordIcon className="dot" />

            <span className="detailsVideo2">{videoDetails.releaseDate}</span>
          </div>
        </div>
        <div>
          <Button
            className={isClicked != "liked" ? "likes" : " clicked"}
            // className="likes"
            style={{ margin: "1px 10px", padding: "5px 10px" }}
            onClick={() => {
              if (isClicked === "") {
                setVideoDetails((prevState) => {
                  return {
                    ...prevState,
                    votes: {
                      ...prevState.votes,
                      upVotes: prevState.votes.upVotes + 1,
                    },
                  };
                });
                handleUpVote();
                setIsClicked("liked");
              } else if (isClicked === "liked") {
                setVideoDetails((prevState) => {
                  return {
                    ...prevState,
                    votes: {
                      ...prevState.votes,
                      upVotes: prevState.votes.upVotes - 1,
                    },
                  };
                });
                setIsClicked("");
              } else {
                setVideoDetails((prevState) => {
                  return {
                    ...prevState,
                    votes: {
                      downVotes: prevState.votes.downVotes - 1,
                      upVotes: prevState.votes.upVotes + 1,
                    },
                  };
                });
                setIsClicked("liked");

                handleDownVote();
                handleUpVote();
              }
            }}
          >
            <ThumbUpAltIcon style={{ margin: "1px 10px" }} />
            {videoDetails.votes.upVotes}
          </Button>
          <Button
            className={isClicked != "disliked" ? "likes" : " clicked"}
            style={{ margin: "1px 10px", padding: "5px 10px" }}
            onClick={() => {
              if (isClicked === "") {
                setVideoDetails((prevState) => {
                  return {
                    ...prevState,
                    votes: {
                      ...prevState.votes,
                      downVotes: prevState.votes.downVotes + 1,
                    },
                  };
                });
                handleDownVote();
                setIsClicked("disliked");
              } else if (isClicked === "disliked") {
                setVideoDetails((prevState) => {
                  return {
                    ...prevState,
                    votes: {
                      ...prevState.votes,
                      downVotes: prevState.votes.downVotes - 1,
                    },
                  };
                });
                setIsClicked("");
              } else {
                setVideoDetails((prevState) => {
                  return {
                    ...prevState,
                    votes: {
                      downVotes: prevState.votes.downVotes + 1,
                      upVotes: prevState.votes.upVotes - 1,
                    },
                  };
                });
                setIsClicked("disliked");
                handleUpVote();
                handleDownVote();
              }
            }}
          >
            <ThumbDownIcon style={{ margin: "1px 10px" }} />
            {videoDetails.votes.downVotes}
          </Button>
        </div>
      </div>
      <Box sx={{ flexGrow: 1 }} className="box">
        <div className="grid">
          <Grid container spacing={1}>
            {allVideo ? (
              allVideo.map((item, idx) => {
                return (
                  <Grid key={item.title} item xm={12} xs={6} md={4} lg={3}>
                    <VideoCard
                      imgLink={item.previewImage}
                      title={item.title}
                      releaseDate={item.releaseDate}
                      _id={item._id}
                      getParam={getParam}
                    />
                  </Grid>
                );
              })
            ) : (
              <></>
            )}
          </Grid>
        </div>
      </Box>
    </div>
  );
}
